<template>
    <div class="contact-us_block margin-t-2">
        <label class="text-s text-color-weak" :for="field.name">{{ field.label }}</label>
        <div
            v-if="!files.length"
            class="drop-zone"
            @dragover.prevent="dragover"
            @dragleave.prevent="dragleave"
            @drop.prevent="drop"
            :class="{ 'is-dragover': isDragging }"
        >
            <div class="icon-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M17 8L12 3M12 3L7 8M12 3V15" stroke="#183147" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <p class="text-m">Drag and drop your Resume here</p>
            <p class="text-m text-color-weak margin-b-2">Please upload a .doc, .docx, .pdf or .txt file limited to 1MB</p>
            <div class="flex justify-center">
                <button class="btn-primary" type="button" @click="triggerInput">Browse Files</button>
            </div>
            <input :name="field.name" type="file" ref="fileInput" @change="handleFileChange" class="hidden-input" :required="field.required" />
        </div>
        <p v-if="error" class="error">{{ error }}</p>
        <p v-if="!field.isValid" class="error">This field is required.</p>
        <div v-if="files.length" class="padding-v-2 border-bottom">
            <div v-for="(file, index) in files" :key="file.name" class="flex gap-2">
                <div class="icon-wrapper background">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9M13 2L20 9M13 2V9H20" stroke="#183147" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div class="flex column grow">
                    <p class="text-m bold">{{ file.name }}</p>
                    <p class="text-color-weak">{{ formatFileSize(file.size) }} KB</p>
                </div>
                <button @click="removeFile(index)">
                    <i>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M18 6L6 18M6 6L18 18" stroke="#183147" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </i>
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from "vue";

const props = defineProps({
    field: {
        type: Object,
        default: {}
    }
})

const files = ref([]);
const fileInput = ref(null);
const isDragging = ref(false);
const error = ref(null);

const allowedTypes = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf', 'text/plain'];

const formatFileSize = (value) => {
    const kb = value / 1024;

    return kb.toFixed()
};

const dragover = (event) => {
    event.preventDefault();
    isDragging.value = true;
};

const dragleave = () => {
    isDragging.value = false;
};

const drop = (event) => {
    event.preventDefault();
    isDragging.value = false;
    const droppedFiles = event.dataTransfer.files;
    if (droppedFiles.length > 0) {
        addFiles(droppedFiles);
    }
};

const triggerInput = () => {
    fileInput.value.click();
};

const addFiles = (newFiles) => {
    error.value = null;
    Array.from(newFiles).forEach((file) => {
        if (!allowedTypes.includes(file.type)) {
            error.value = `Invalid file type: ${file.name}. Only .doc, .docx, .pdf and .txt are allowed.`;
            return;
        }
        files.value.push(file);
    })
};

const handleFileChange = (event) => {
    addFiles(event.target.files);
};

const removeFile = (index) => {
    files.value.splice(index, 1);
};

watch(files, () => {
    props.field.value = files;
    console.log('add file')
}, { deep: true });

</script>
